import React, { useState } from "react";
import MainMenu from "../components/navigations/MainMenu";
import { saveAs } from "file-saver";

const FeesStructure = () => {
  const [embedURL] = useState(
    "https://drive.google.com/file/d/1QLvxVvIHUU-pwZQUI4v0sMHfWh9fqOxi/preview"
  );

  const saveFile = () => {
    saveAs(
      "https://drive.google.com/file/d/1QLvxVvIHUU-pwZQUI4v0sMHfWh9fqOxi/view?usp=sharing",
      "Fees Structure.pdf"
    );
  };

  return (
    <div className="relative">
      <div className="absolute top-0 left-0">
        <MainMenu bg="gray-900" />
      </div>
      <div className="py-32 max-w-6xl mx-auto">
        <div>
          <h1 className="text-center text-3xl font-serif pb-6">
            Fees Structure
          </h1>
          <div className="flex justify-center my-3">
            <button
              onClick={saveFile}
              className="bg-blue-700 text-white p-2 px-4 rounded"
            >
              Download
            </button>
          </div>
        </div>
        <iframe
          src={embedURL}
          width="92%"
          height="800"
          allow="autoplay"
        ></iframe>
      </div>
    </div>
  );
};

export default FeesStructure;
